/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Save_Project_Success_ToastInputs */

const en_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save project completed successfully`)
};

const fr_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet termine avec succes`)
};

const de_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt erfolgreich gespeichert`)
};

const it_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio del progetto completato con successo`)
};

const ru_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект успешно завершен.`)
};

const es_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar proyecto completado exitosamente`)
};

const zh_cn2_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目保存已成功完成`)
};

const ja_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの保存が正常に完了しました`)
};

const hi_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सफलतापूर्वक पूरा हो गया`)
};

const pt_pt2_shortcut_keys_save_project_success_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto concluído com sucesso.`)
};

/**
* | output |
* | --- |
* | "Save project completed successfully" |
*
* @param {Shortcut_Keys_Save_Project_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_save_project_success_toast = /** @type {((inputs?: Shortcut_Keys_Save_Project_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Save_Project_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "de") return de_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "it") return it_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "es") return es_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_save_project_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_save_project_success_toast(inputs)
	return en_shortcut_keys_save_project_success_toast(inputs)
});